'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    confirmLabel: 'Done',
    backspaceLabel: 'Backspace',
    cancelKeyboardLabel: 'CancelKeyboard'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/input-item/locale/en_US.js
// module id = 1333
// module chunks = 1